import styled from 'styled-components';
import { SIZE, LAYERS } from '../../common/sizes';
import { DEFAULT_FONT_FAMILY } from 'common/constants';
import { Label } from 'common/baseComponents';

export const InputFieldMainContainer = styled.div`
    display: flex;
    flex:1;
    justify-content: flex-start;
    padding: 0 ${SIZE.ONE}px;
`;

export const LabelContainer = styled.div`
    display: flex;
    color: #111;
    aling-items: center;
    margin: 0 ${SIZE.ONE}px;
    ${Label} {
        color: inherit;
        font-size: 14px;
        align-items: center;
    }
`;

export const InputContainer = styled.div`
    display: flex;
    margin: 0 ${SIZE.ONE}px;
    box-shadow: 1px 1px 6px 1px rgba(0, 0, 0, 0.16);
`;

export const ActionContainer = styled.div`
    display:flex;
    align-items: center;
    margin: 0 ${SIZE.ONE}px;
    & : hover {
        cursor: pointer;
    }
`

export const Input = styled.input`
    margin-left: ${SIZE.TWO}px;
    display: flex;
    font-family: ${DEFAULT_FONT_FAMILY};
    font-size: 14px;
    text-align: left;
    color: #111;
    outline: none;
    border: none;
    width: 100%;
`
